module.exports = __webpack_public_path__ + "/061c51ec571533c5aec55c7fb4d3d1b3.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/v2/assets/boat_icon.svg
 ** module id = 1167
 ** module chunks = 0
 **/